import { Component, OnInit } from '@angular/core';
import { CmsService } from 'src/app/services/api/cms.service';
import { WinService } from 'src/app/services/win.service'; 
// import { LangService } from 'src/app/services/lang/lang.service';
import { SettingsService } from 'src/app/services/site/settings.service';
// import { Meta, Title } from '@angular/platform-browser';
import { Title }     from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent implements OnInit {

	
	activeItems: any = null;
	// iconClass: any = null;
	// activeItemsIcons: any = null;
	env = environment;

	constructor(
	    public winService: WinService,
	    public cms: CmsService,
		// public title: Title,
	    // public lang: LangService,
		public site: SettingsService,
		// private meta: Meta,
		public title: Title
    ) { }

	ngOnInit() {
		this.title.setTitle('Custom Stickers');
		this.cms.getBlock(3, false, true);
		this.cms.getBlock(59, true, false);
		
		let url = this.site.mainService.getStoreUrl('/V1/lns-entrelabel/config/site/setting');
		this.site.getConfigPromise(url,"site_settings").then((config:any) => {
			this.activeItems = config.site_settings.active_items;
		});
		// this.site.getConfigPromise("/rest/entrelable/V1/lns-entrelabel/config/site/setting","site_settings").then((config) => {
		// 	let c: any = config;
		// 	if (typeof c.site_settings != "undefined") {
		// 		this.activeItems = c.site_settings.active_items;

		// 		this.cms.getBlock(67, false, true).then((content:any) => {
		// 			this.activeItemsIcons = [];
		// 			content.content.forEach(cont => {
		// 				let conSku = cont.sku;

		// 				let inActiveItems = false;
		// 				this.activeItems.forEach(item => {
		// 					if(item.sku == cont.sku){
		// 						this.activeItemsIcons.push(cont);
		// 						if(!this.site.cssAdded){
		// 							this.setIconStyle(cont);
		// 						}
		// 					}
		// 				});
		// 			});

		// 			this.site.cssAdded = true;

		// 			this.iconClass = 'col-sm-12 col-md-4 col-lg-4';
		// 			if(this.activeItemsIcons.length){
		// 				let col:any = 12 / this.activeItemsIcons.length;
		// 				col = parseInt(col);

		// 				this.iconClass = 'col-sm-12 col-md-'+col+' col-lg-'+col;

		// 			}
		// 		});
		// 	}
		// });
	}

	setIconStyle(item:any){
		let style =  `
			<style >
				.product-con .product-item.`+item.sku+`:hover {
					background: `+item.hover_background+`;
				}
			</style>
		`;
		document.head.insertAdjacentHTML("beforeend", style)
	}
}
